import { jsx as _jsx } from "react/jsx-runtime";
import { PlateElement } from '@udecode/plate/react';
import { forwardRef } from 'react';
/**
 * Wrapper component that adds ID from node metadata
 * This enhances any Plate element by adding an ID attribute if the node has ID metadata
 */
export const PlateElementWithId = forwardRef(({ element, children, ...props }, ref) => {
    // Check if the element has ID metadata
    const elementId = element.id;
    // Pass the ID to the PlateElement
    return (_jsx(PlateElement, { ref: ref, element: element, id: elementId, ...props, children: children }));
});
PlateElementWithId.displayName = 'PlateElementWithId';
